// 持久化动画class名称，用于在失焦时query这些dom并注入animation: unset
export const STABLE_ANIMATION_CLASS_NAME = 'common-stable-animation'

export const DEFAULT_ELECTRON_SERVER_PORT = 31088
export const DEFAULT_ELECTRON_SERVER_STEP = 100
export const DEFAULT_ELECTRON_SERVER_RETRY_TIMES = 5

export const MESSAGE_MP3 = 'https://static.max-c.com/static/heybox-chat/audio/message.mp3'

export const ERROR_IMG = {
  dark: 'https://imgheybox.max-c.com/oa/2024/04/23/4830427addc162c859592a607490dfa7.png',
  light: 'https://imgheybox.max-c.com/oa/2024/04/23/a1064e3033f99dc607872f043d180fec.png'
}

export const CHAT_LOGO_IMG = 'https://imgheybox.max-c.com/oa/2024/05/16/87de3fc703b79e332bfd00cd510299aa.png'

export const JUMP_ROOM_CHANNEL_EVENT = 'Standardized_Jump_Room_Channel'